export default "__VITE_ASSET__61a8e9ac__"